/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UpdateCommodityGroupsByIdRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CommodityGroupsMassUpdates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name UpdateCommodityGroups
   * @request POST:/commodityGroups-mass-updates
   * @secure
   */
  updateCommodityGroups = (data: UpdateCommodityGroupsByIdRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodityGroups-mass-updates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCommodityGroupsMassUpdates
   * @request OPTIONS:/commodityGroups-mass-updates
   */
  optionsCommodityGroupsMassUpdates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodityGroups-mass-updates`,
      method: 'OPTIONS',
      ...params,
    });
}
